import { render, staticRenderFns } from "./ListUpdates.vue?vue&type=template&id=2c2a3c40&"
import script from "./ListUpdates.vue?vue&type=script&lang=js&"
export * from "./ListUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports